import { formatTranslation as f } from '@utils/strings'
import { h, computed, toRefs } from 'vue'
import { i18n } from '@/i18n'

// import { DATE_CONFIG } from '@md/ui/components/controls/DatePicker';
const { t: $t, d: $d, n: $n } = i18n.global

const RendererMixin = {
  props: ['filter', 'value'],
}

function renderValue(context, props, value) {
  const { filter } = props
  return () =>
    h('span', { class: 'chips__el' }, [
      f('<[caption]>: <[value]>', { caption: filter.title, value }),
    ])
}

export const SimpleRenderer = {
  mixins: [RendererMixin],
  setup(props, context) {
    return () =>
      h('span', { class: 'chips__el' }, [
        f('<[caption]>: <[value]>', {
          caption: props.filter.title,
          value: props.value,
        }),
      ])
  },
}
export const SelectRenderer = {
  mixins: [RendererMixin],
  setup(props, context) {
    return renderValue(context, props, props.value.title)
  },
}

export const MultiselectRenderer = {
  mixins: [RendererMixin],
  setup(props, context) {
    const { value, filter } = toRefs(props)
    const compiled = computed(() =>
      (value.value || []).map((el) => el?.title || el?.value_verbose).join(', ')
    )
    return () =>
      h('span', { class: 'chips__el' }, [
        f('<[caption]>: <[value]>', {
          caption: filter.value.title,
          value: compiled.value,
        }),
      ])
  },
}
export const BrandsModelsRenderer = {
  mixins: [RendererMixin],
  setup(props, context) {
    const { value, filter } = toRefs(props)
    const compiled = computed(() =>
      (value.value || []).map((el) => el?.title || el?.value_verbose).join(', ')
    )
    return () =>
      h('span', { class: 'chips__el' }, [
        value.value.model?.title
          ? f('<[caption]>: <[value]>', {
              caption: value.value.brand.title,
              value: value.value.model.title,
            })
          : f('<[caption]>', { caption: value.value.brand.title }),
      ])
  },
}
export const RangeRenderer = {
  mixins: [RendererMixin],
  setup(props, context) {
    const { value, filter } = toRefs(props)
    const compiled = computed(() => {
      if (value.value?.min && value.value?.max) {
        return $t('from') + ` ${value.value.min} ${$t('to')} ${value.value.max}`
      }
      if (value.value?.min) {
        return $t('from') + ` ${value.value.min}`
      }
      if (value.value?.max) {
        return $t('to') + ` ${value.value.max}`
      }
      return value.value?.min || value.value?.max || ''
    })
    return () =>
      h('span', { class: 'chips__el' }, [
        f('<[caption]>: <[value]>', {
          caption: filter.value.title,
          value: compiled.value,
        }),
      ])
  },
}

// export const SliderRenderer = {
//   mixins: [RendererMixin],
//   render(h, context) {
//     const { value } = context.props;
//     const { min, max } = value;
//     const _ = context.parent._.bind(context.parent);
//     let compiled = '';
//     if ('min' in value && 'max' in value) {
//       compiled = f(_('От <[min]> до <[max]>'), { min, max });
//     } else if ('min' in value) {
//       compiled = f(_('От <[min]>'), { min });
//     } else if ('max' in value) {
//       compiled = f(_('До <[max]>'), { max });
//     }

//     return renderValue(h, context, compiled);
//   },
// };

// // export const DateRangeRenderer = {
// //   mixins: [RendererMixin],
// //   render(h, context) {
// //     const { value } = context.props;
// //     const _ = context.parent._.bind(context.parent);
// //     const d = context.parent.$d.bind(context.parent);
// //     const starts = d(new Date(value.starts), DATE_CONFIG);
// //     const ends = d(new Date(value.ends), DATE_CONFIG);

// //     let compiled = '';
// //     if (starts !== ends) {
// //       compiled = f(_('<[starts]> - <[ends]>'), { starts, ends });
// //     } else {
// //       compiled = f(_('<[starts]>'), { starts });
// //     }

// //     return renderValue(h, context, compiled);
// //   },
// // };

// export const CombinedInputRenderer = {
//   mixins: [RendererMixin],
//   render(h, context) {
//     const { value } = context.props;

//     return renderValue(h, context, `${value.element.caption} / ${value.search}`);
//   },
// };

// export const AutocompleteMultiselectRenderer = MultiselectRenderer;
